import styled, { css } from 'styled-components';
import { devices } from '../../../juristec-ui/core/breakpoints';
import { gap } from '../../../juristec-ui/styles/theme';

export const MainContainer = styled.div`
  padding: 0 5%;
  @media ${devices.tablet} {
    padding: 0 20px;
  }
  & .left {
    width: 100%;
    flex-shrink: 2;
    position: relative;
    justify-content: flex-start;
    & span {
      position: absolute;
      font-size: 12px;
      font-weight: bold;
      margin-left: 20px;
      color: ${({ theme }) => theme.color};
    }
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DescriptionItens = styled(Row)`
  ${gap('10px', 'row')}
  align-items: center;
  height: 100%;
`;

export const DescriptionOptions = styled.div`
  color: ${({ theme }) => theme.toolbarFont};
  text-decoration: none;
  padding: 0 5px;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: bold;
  border-bottom: 4px solid transparent;
  box-sizing: border-box;
  text-align: center;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }

  ${({ active, theme }) => active && css`
    color: ${theme.primary};
    border-bottom-color: ${theme.primary};
  `}
`;

export const ScrollContainer = styled.div`
  max-height: calc(100vh - 200px);
  overflow: auto;
  & .type-picker {
    cursor: pointer;
  }
  & .cc-type-picker {
    cursor: default;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & svg {
    fill: ${({ theme }) => theme.white};
  }
`;

export const IconFlipWrapper = styled(IconWrapper)`
  transition: all 0.5s;
  ${(props) => props.flip
    && css`
      transform: rotate(180deg);
    `}
`;

export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  user-select: none;
  justify-content: space-between;
  align-items: center;
  ${gap('40px', 'row')}
  padding: .2rem 0 .5rem;

  & .invert svg {
    transform: rotate(180deg);
  }
`;

PaginationContainer.Selects = styled.div`
  display: flex;
  ${gap('10px', 'row')}
`;

PaginationContainer.ArrowBtns = styled.div`
  margin-top: 11px;
  display: flex;
  align-items: center;
  ${gap('5px', 'row')}
`;

export const LegendsContainer = styled.div`
  margin-top: 11px;
  margin-right: 120px;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  & .legend-type { 
    display: flex;
    align-items: center;
  };

  @media ${devices.tablet} {
    display: none;
  }

  & .square { 
    height: 20px;
    width: 20px;
    border-radius: 5px;
    margin-right: 5px;
  }
  
  & .legend-texto { 
    background: ${({ theme }) => theme.typeText};
  }

  & .legend-numero { 
    background: ${({ theme }) => theme.typeNumber};
  }

  & .legend-date {
    background: ${({ theme }) => theme.typeDate};
  }
`;
